var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shortlist col-xs-12 col-sm-6 col-lg-4" }, [
    _c("div", [
      _c("div", { staticClass: "col-xs-4" }, [
        _c("img", { attrs: { src: _vm.user.profile_image_url } }),
        _vm._v(" "),
        _c("span", { staticClass: "position" }, [
          _vm._v(_vm._s(_vm.user.response.priority)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-8" }, [
        _c("div", { staticClass: "description-small" }, [
          _c("h4", [
            _vm._v("\n          " + _vm._s(_vm.user.name) + "\n          "),
            _vm.user.profile.visibility === "hidden" &&
            (_vm.$userIsAdmin || _vm.$userIsManager)
              ? _c("i", {
                  staticClass: "fa fa-eye-slash text-grey",
                  attrs: { "aria-label": "hidden", title: "hidden" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.user.profile.visibility === "private" &&
            (_vm.$userIsAdmin || _vm.$userIsManager)
              ? _c("i", {
                  staticClass: "fa fa-lock text-grey",
                  attrs: { "aria-label": "private", title: "private" },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.user.profile.tagline))]),
          _vm._v(" "),
          !_vm.$clientConfig.hide_social_media_references
            ? _c(
                "p",
                {
                  attrs: {
                    title: `${_vm.user.profile.highest_followers} followers`,
                  },
                },
                [
                  _c("i", {
                    class: ["fab", _vm.user.profile.highest_followers_icon],
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("abbreviatedNumber")(
                          _vm.user.profile.highest_followers
                        )
                      ) +
                      " followers\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "text-align": "right" } }, [
      _vm.editing
        ? _c(
            "a",
            {
              staticStyle: { "padding-right": "30px", cursor: "pointer" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleRemoveCallback.apply(null, arguments)
                },
              },
            },
            [_vm._v("Remove")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }